<template>
	<!-- 筛选条件 -->
	<div class="screening_condition" v-show="show" :style="this.$route.path.indexOf('teamList')||this.$route.path.indexOf('searchResult')==1?'height: 45px;background: #fff;border-bottom:none':this.$route.path.indexOf('LaborServiceCompany')==1?'height: 46px;background: #fff;border-top:1px solid #E4E7ED':'height: 46px;margin-top:-10px;border:none'">
		<div class="px14 bold screening_header">筛选条件:</div>
		<div ref="list" class="list">
      <!--  工程分类  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in secondCategory" :key="'secondCategory'+index">
        <div class="img_clear" @click="close('secondCategory',index);secondCategory.splice(index)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  工种名称  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in workType" :key="'workType'+index">
        <div class="img_clear" @click="close('workType',item);workType.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  团队类型  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in teamType" :key="'teamType'+index">
        <div class="img_clear" @click="close('teamType',item);teamType.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  团队规模  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in teamSize" :key="'teamSize'+index">
        <div class="img_clear" @click="close('teamSize',item);teamSize.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.ranges}}</span>
      </div>
      <!--  行业类别+专业分类  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in industryType" :key="'industryType'+index">
        <div class="img_clear" @click="close('industryType',index);industryType.splice(index)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  企业类型  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in enterpriseType" :key="'enterpriseType'+index">
        <div class="img_clear" @click="close('enterpriseType',item);enterpriseType.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.label}}</span>
      </div>
      <!--  报名结束时间  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in timeList" :key="'timeList'+index">
        <div class="img_clear" @click="close('timeList',item);timeList.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  筛选  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in recruitType" :key="'recruitType'+index">
      <template v-if="item.desc">
        <div class="img_clear" @click="close('recruitType',item);recruitType.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.desc}}</span>
      </template>
      </div>
      <!--  综合筛选  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in workyearAndLevel" :key="'workyearAndLevel'+index">
      <template v-if="item.desc">
        <div class="img_clear" @click="close('workyearAndLevel',item);workyearAndLevel.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.desc}}</span>
      </template>
      </div>
      <!--  更多筛选  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in verticalTypeAndPice" :key="'verticalTypeAndPice'+index">
      <template v-if="item.desc">
        <div class="img_clear" @click="close('verticalTypeAndPice',item);verticalTypeAndPice.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </template>
      </div>
      <!--  省份  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in areacodeList" :key="'areacodeList'+index">
        <div class="img_clear" @click="close('areacodeList',index);areacodeList.splice(index)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  临时用工-薪资方式  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in salaryType" :key="'salaryType'+index">
        <div class="img_clear" @click="close('salaryType',item);salaryType.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  施工队-综合筛选  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in teamScreen" :key="'teamScreen'+index">
      <template v-if="item.name">
        <div class="img_clear" @click="close('teamScreen',item);teamScreen.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </template>
      </div>
      <!--  劳务公司-综合筛选  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in laborScreen" :key="'laborScreen'+index">
      <template v-if="item.name">
        <div class="img_clear" @click="close('laborScreen',item);laborScreen.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </template>
      </div>
      <!--  工程公司-资质类型  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in aptitudeType" :key="'aptitudeType'+index">
        <div class="img_clear" @click="close('aptitudeType',index);aptitudeType.splice(index)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  工程公司-综合筛选  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in engineeringScreen" :key="'engineeringScreen'+index">
        <div class="img_clear" @click="close('engineeringScreen',item);engineeringScreen.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
      <!--  所在地区  -->
      <div class="screening_property flex_jc_sb" v-for="(item,index) in locationAddress" :key="'locationAddress'+index">
        <div class="img_clear" @click="close('locationAddress',item);locationAddress.splice(index,1)">
          <i class="el-icon-close"></i>
        </div>
        <span>{{item.name}}</span>
      </div>
		</div>
		<div class="closeAll" @click="closeAll()" v-show="show">清空筛选</div>
	</div>
</template>

<script>
	export default {
		name: 'Screen',
		components: {},
		data() {
			return {
        //工程分类
        secondCategory:[],
        //工种名称
        workType:[],
        //团队类型
        teamType:[],
        //团队规模
        teamSize:[],
        //行业类别+专业分类
        industryType:[],
        //企业类型
        enterpriseType:[],
        //报名结束时间
        timeList:[],
        //筛选
        recruitType:[],
        //综合筛选
        workyearAndLevel:[],
        //更多筛选
        verticalTypeAndPice:[],
        //省份
        areacodeList:[],
        //所在地区
        locationAddress:[],
        locationAddresscode:{
          provinceId: '',
          cityId: '',
          cityName: '',
          isAll: '',
        },
        config:[],
        timer:'',//防抖计时器
        //薪资方式
        salaryType:[],
        //施工队-综合筛选
        teamScreen:[],
        //劳务公司-综合筛选
        laborScreen:[],
        //工程公司-资质类型
        aptitudeType:[],
        //工程公司-综合筛选
        engineeringScreen:[],
      }
		},
		props: {},
		computed: {
      show(){
        let t=this;
        let show=false;
        let obj={locationAddresscode:{}};
        this.config.forEach(v=>{
          if(t[v]&&t[v].length>0){
            show=true;
            obj[v]=t[v];
          }
          if(v=='locationAddress'){
            obj.locationAddresscode=t.locationAddresscode
          }
        })
        /*防抖*/
        if(this.timer){
          clearTimeout(this.timer) //进入该分支语句，说明当前正在一个计时过程中，并且又触发了相同事件。所以要取消当前的计时，重新开始计时
        }
        this.timer = setTimeout(()=>{
          t.$parent.change(obj);
        },300) // 进入该分支说明当前并没有在计时，那么就开始一个计时
        return show;
      }
    },
		methods: {
      closeAll(){
        this.$emit('closeAll')
        this.$store.commit('SET_FirstCategoryNo', '')
      },
      close(ref,item){
        this.$parent.$refs[ref].close(item)
        this.$store.commit('SET_FirstCategoryNo', '')
      }
    },
		watch: {},
		created() {},
		mounted() {
		  this.config=this.$parent.config;
    }
	}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
	.screening_header {
		width: 130px;
		text-align: center;
		font-size: 14px;
		height: 33px;
		line-height: 33px;
	}

	.screening_condition {
		display: flex;
		margin: 0 auto;
		width: 1198px;
		align-items: center;
    border-top: 1px solid #E4E7ED;
    border-right: 1px solid #E4E7ED;
    border-left: 1px solid #E4E7ED;
	}

	.screening_inner {
		padding: 5px;
		font-size: 14px;
		display: inline-block;
		background: #fff;
		color: #747474;
		border: 1px solid #e8e8e8;
		border-radius: 3px;
		margin-right: 5px;
	}

	.screening_property {
		height: 25px;
		line-height: 25px;
		padding: 0 20px 0 13px;
		font-size: 14px;
		display: inline-block;
		background-color: #f5f7fa;
		color: #969696;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		margin-right: 10px;

		.img_clear {
			width: 0px;
			height: 0px;
			display: inline-block;
			margin: 0 0 0 5px;
			cursor: pointer;
			float: right;
			position: relative;
			right: -2px;
		}
	}

	.closeAll {
		font-size: 14px;
		color: #666666;
		font-family: MicrosoftYaHei;
		font-weight: 400;
		cursor: pointer;
	}

	.bold {
		font-weight: 400;
		color: #666666;
	}
  .list{
    display: inline-block;
    max-width: calc(100% - 190px);
    display: flex;overflow-x: auto;
    overflow-y: hidden;
  }
</style>
